import React from 'react'
import { array, object } from 'prop-types'
import EventAgendaNavigator from '@/component/Primitive/Events/components/EventAgendaNavigator'
import createButtonGroup from '@/component/Widgets/lib/button-group-creator'

const EventAgendaNavigatorWidget = (props) => {
  const { eventUmbrella, buttonGroup, pageData } = props
  const createEventUrl = (path) => {
    let finalPath
    if (!eventUmbrella?.event) return null
    if (!path) finalPath = ''
    else finalPath = '/' + path
    return (
      'events/' +
      eventUmbrella?.slug +
      '/' +
      eventUmbrella?.event?.slug +
      finalPath
    )
  }

  return (
    <EventAgendaNavigator
      {...props}
      baseURL={createEventUrl()}
      buttonGroup={createButtonGroup(pageData, buttonGroup)}
    />
  )
}

EventAgendaNavigatorWidget.propTypes = {
  eventUmbrella: object,
  buttonGroup: array,
  pageData: object
}

export default EventAgendaNavigatorWidget
